<template>
  <v-container fluid>
    <h1 class="mb-2 text-h4">
      Search Results for "{{ form.query }}"
    </h1>
    <v-divider class="mb-2"></v-divider>
    <div class="d-flex">
      <div v-if="1===2"
           class="Search__Facets mr-4">
        <v-card>
          <v-card-text class="pb-0">
            <div class="font-weight-bold">
              Type
            </div>
            <div v-for="type in typeFacets"
                 :key="type.id">
              <a href="#">
                {{ type.name }} ({{ type.matches }})
              </a>
            </div>
          </v-card-text>
          <v-card-text>
            <div class="font-weight-bold">
              Labels
            </div>
            <div v-for="label in labelFacets"
                 :key="label.id">
              <a href="#">
                {{ label.name }} ({{ label.matches }})
              </a>
            </div>
          </v-card-text>
        </v-card>
        <pre v-if="1===2">{{ facets }}</pre>
      </div>
      <div class="flex-grow-1">
        <div class="Search__Pagination d-flex justify-space-between align-center mb-4">
          <div>
            <v-select label="Sort by"
                      v-model="form.sort"
                      :items="sortOptions"
                      item-value="id"
                      item-text="name"
                      hide-details
                      outlined
                      dense
                      style="max-width: 300px;"
                      @change="changeSortOrder">
            </v-select>
          </div>
          <div class="text-nowrap">
            <v-btn icon
                   title="Detail view"
                   :color="layout === 'detail' ? 'success' : ''"
                   @click.prevent="setLayout('detail')">
              <v-icon>
                fas fa-th-list
              </v-icon>
            </v-btn>

            <v-btn icon
                   title="Tile view"
                   :color="layout === 'tile' ? 'success' : ''"
                   @click.prevent="setLayout('tile')">
              <v-icon>
                fas fa-th-large
              </v-icon>
            </v-btn>

            <v-btn v-if="1===2"
                   icon
                   title="Tabular view"
                   :color="layout === 'table' ? 'success' : ''"
                   @click.prevent="setLayout('table')">
              <v-icon>
                fas fa-table
              </v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center">
            <div v-if="hits && hits.length"
                 class="mr-4">
              {{ results.offset + 1 }}-{{ results.offset + hits.length }} of {{ results.nbHits }}
            </div>
            <v-btn :disabled="!hasOffset"
                   @click.prevent="previousPage"
                   class="mr-2">
              Previous
            </v-btn>

            <v-btn :disabled="!hasMoreResults"
                   @click.prevent="nextPage">
              Next
            </v-btn>
          </div>
        </div>

        <p v-if="form.busy"
           class="text-center">
          <v-progress-circular indeterminate
                               size="100">
          </v-progress-circular>
        </p>

        <div v-else
             class="Search__Results">

          <template v-if="hits && hits.length">

            <div v-if="isDetailView"
                 class="Search__Results-Details">
              <presentation-hit v-for="hit in hits"
                                :key="hit.id"
                                :hit="hit">
              </presentation-hit>
            </div>
            <div v-else-if="isTileView"
                 class="Search__Results-Tiles">
              <presentation-card v-for="presentation in presentationHits"
                                 :key="presentation.id"
                                 :presentation="presentation">
              </presentation-card>
            </div>
            <div v-else-if="isTableView"
                 class="Search__Results-Table">
              TABLE
            </div>
          </template>
          <v-card v-else
               class="mt-6">
            <v-card-title>
              Your search for '{{ form.query }}' did not match any documents.
            </v-card-title>
            <v-card-text>
              <ul>
                <li>
                  Check that all words are spelled correctly.
                </li>
                <li>
                  Make sure alphanumeric searches are accurate including spaces or dashes.
                </li>
                <li>
                  Try using different search terms
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </div>

      </div>
    </div>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {find, forOwn, isEqual, orderBy} from 'lodash';
import slugify from '../../plugins/slugify';
import PresentationHit from "./components/PresentationHit";
import PresentationCard from "../content/components/PresentationCard";

// MLD-3584
const RESULTS_LIMIT = 20;

export default {
  components: {PresentationCard, PresentationHit},
  data() {
    return {
      error: null,
      form: new Form({
        query: '',
        offset: 0,
        limit: RESULTS_LIMIT, // MLD-3584 10,
        nonce: null,
        sort: '',
      }),
      sortOptions: [
        {id: '', name: 'Relevance'},
        {id: 'created_at:desc', name: 'Creation Date (Newest First)'},
        {id: 'created_at:asc', name: 'Creation Date (Oldest First)'},
        {id: 'name:asc', name: 'Name (A-Z)'},
        {id: 'name:desc', name: 'Name (Z-A)'},
        {id: 'external_id:asc', name: 'Asset ID (A-Z)'},
        {id: 'external_id:desc', name: 'Asset ID (Z-A)'},
        {id: 'updated_at:desc', name: 'Modified Date (Newest First)'},
        {id: 'updated_at:asc', name: 'Modified Date (Oldest First)'},
      ]
    }
  },
  computed: {
    ...mapGetters([
      'labels',
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'presentations',
    ]),
    ...mapGetters('search', [
      'layout',
      'results',
    ]),
    isDetailView() {
      return this.layout === 'detail';
    },
    isTileView() {
      return this.layout === 'tile';
    },
    isTableView() {
      return this.layout === 'table';
    },
    typeFacets() {
      if (this.facets && this.facets.presentation_type) {
        const types = [];
        forOwn(this.facets.presentation_type, (value, type) => {
          types.push({
            id: type,
            name: type,
            slug: slugify(type, {lower: true, replacement: '_',}),
            matches: value,
          })
        })
        return orderBy(types, ['slug'], ['asc']);
      }
      return null;
    },
    labelFacets() {
      if (this.facets && this.facets.labels) {
        const labels = [];
        forOwn(this.facets.labels, (value, labelID) => {
          const label = find(this.labels, l => l.id === parseInt(labelID));
          if (label) {
            labels.push({
              id: label.id,
              name: label.name,
              slug: label.slug,
              matches: value,
            })
          }
        })
        return orderBy(labels, ['slug'], ['asc']);
      }
      return null;
    },
    facets() {
      if (this.results && this.results.facetsDistribution) {
        return this.results.facetsDistribution;
      }
      return null;
    },
    hits() {
      if (this.results && this.results.hits) {
        return this.results.hits;
      }
      return null;
    },
    presentationHits() {
      const presentations = [];
      this.hits.forEach(hit => {
        const presentation = find(this.presentations, p => p.id === hit.id);
        if (presentation) {
          presentations.push(presentation);
        }
      })
      return presentations;
    },
    hasOffset() {
      return this.results && this.results.offset > 0;
    },
    hasMoreResults() {
      if (this.results && this.results.nbHits > (this.results.offset + this.hits.length)) {
        return true;
      }
      return null;
    }
  },
  created() {
    this.form.query = this.$route.query.query;
    this.form.offset = 0;
    this.form.limit = RESULTS_LIMIT;
    this.form.nonce = this.$route.query.nonce;
    if (!this.form.query) {
      this.form.sort = 'name:asc';
    }
    this.search(this.form.query, this.form.offset, this.form.limit, this.form.nonce, this.form.sort);
  },
  beforeRouteUpdate(to, from, next) {
    if (from.query.nonce !== to.query.nonce) {
      this.search(to.query.query, 0, this.form.limit, to.query.nonce);
    }
    next();
  },
  methods: {
    setLayout(layout) {
      this.$store.dispatch('search/setLayout', layout);
    },
    previousPage() {
      if (this.results && this.results.offset > 0) {
        const offset = Math.max(this.form.offset - this.form.limit, 0);
        this.search(this.form.query, offset, this.form.limit, this.form.nonce, this.form.sort)
      }
    },
    nextPage() {
      if (this.hasMoreResults) {
        const offset = this.form.offset + Math.min(this.form.limit);
        this.search(this.form.query, offset, this.form.limit, this.form.nonce, this.form.sort)
      }
    },
    changeSortOrder() {
      this.search(this.form.query, this.form.offset, this.form.limit, this.form.nonce, this.form.sort)
    },
    search(query, offset, limit, nonce, sort) {
      if (this.form.busy) {
        return;
      }
      this.form.query = query;
      const form = this.form.data();
      form.offset = offset;
      form.limit = limit;
      form.sort = sort;
      this.form.startProcessing();
      this.$store.dispatch('search/search', form)
        .then(() => {
          if (this.results) {
            this.form.offset = this.results.offset;
            this.form.limit = this.results.limit;
          } else {
            this.form.offset = 0;
            this.form.limit = RESULTS_LIMIT;
          }
          this.form.sort = sort;
          this.form.finishProcessing();
          const q = {
            offset: this.$route.query.offset,
            query: this.$route.query.query,
            nonce: this.$route.query.nonce,
            sort: this.$route.query.sort,
          }
          const f = {
            offset: this.form.offset,
            query: this.form.query,
            nonce: nonce,
            sort: sort,
          }
          if (!isEqual(q, f)) {
            this.$router.push({
              name: `${this.$root.routePrefix}.search`,
              query: f
            })
          }
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            this.$store.dispatch('setErrorMessage', err.response.data.message);
          } else {
            this.$store.dispatch('setErrorMessage', 'Search Error');
          }
          this.$store.commit('search/setResults', null);
        })
        .finally(() => {
          this.form.busy = false;
        })
    }
  }
}
</script>
